function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Service from '@ember/service';
export const STORAGE_CONSTANTS = Object.freeze({
  PREFIX: 'EMBER_MULTIPASS_COMPONENTS',
  LOGIN_COUNT: 'LOGIN_COUNT',
  LAST_2FA_PROMO_PROMPT_DATE: 'LAST_2FA_PROMO_PROMPT_DATE',
  TWO_FACTOR_PROMO_PROMPT_COUNT: 'TWO_FACTOR_PROMO_PROMPT_COUNT',
  VIEW_PASSKEY_PROMO: 'VIEW_PASSKEY_PROMO',
  RISK_MAGIC_LINK_SENT: 'RISK_MAGIC_LINK_SENT',
  PASSKEY_AUTO_ENROLL: 'PASSKEY_AUTO_ENROLL'
});
export default class StorageService extends Service {
  constructor() {
    super(...arguments);
  }
  _getStorageKey(key) {
    return `${STORAGE_CONSTANTS.PREFIX}.${key}`;
  }
  _hasStorageItem(key) {
    return localStorage.getItem(this._getStorageKey(key)) !== null;
  }
  _getStorageItem(key) {
    if (this._hasStorageItem(key)) {
      return JSON.parse(localStorage.getItem(this._getStorageKey(key)));
    }
    return undefined;
  }
  _setStorageItem(key, val) {
    localStorage.setItem(this._getStorageKey(key), JSON.stringify(val));
  }
  _removeStorageItem(key) {
    localStorage.removeItem(this._getStorageKey(key));
  }
  getLoginCount() {
    if (!this._hasStorageItem(STORAGE_CONSTANTS.LOGIN_COUNT)) {
      return undefined;
    }
    const {
      count
    } = this._getStorageItem(STORAGE_CONSTANTS.LOGIN_COUNT);
    return count;
  }
  setLoginCount(count) {
    this._setStorageItem(STORAGE_CONSTANTS.LOGIN_COUNT, {
      count
    });
  }
  getLastTwoFactorPromoPromptDate() {
    if (!this._hasStorageItem(STORAGE_CONSTANTS.LAST_2FA_PROMO_PROMPT_DATE)) {
      return undefined;
    }
    const {
      date
    } = this._getStorageItem(STORAGE_CONSTANTS.LAST_2FA_PROMO_PROMPT_DATE);
    return date;
  }
  setLastTwoFactorPromoPromptDate(date) {
    this._setStorageItem(STORAGE_CONSTANTS.LAST_2FA_PROMO_PROMPT_DATE, {
      date
    });
  }
  getTwoFactorPromoPromptCount() {
    if (!this._hasStorageItem(STORAGE_CONSTANTS.TWO_FACTOR_PROMO_PROMPT_COUNT)) {
      return undefined;
    }
    const {
      count
    } = this._getStorageItem(STORAGE_CONSTANTS.TWO_FACTOR_PROMO_PROMPT_COUNT);
    return count;
  }
  setTwoFactorPromoPromptCount(count) {
    this._setStorageItem(STORAGE_CONSTANTS.TWO_FACTOR_PROMO_PROMPT_COUNT, {
      count
    });
  }
  getPasskeyPromoViewDontRemindDate() {
    if (!this._hasStorageItem(STORAGE_CONSTANTS.VIEW_PASSKEY_PROMO)) {
      return;
    }
    const {
      date
    } = this._getStorageItem(STORAGE_CONSTANTS.VIEW_PASSKEY_PROMO);
    return date;
  }
  setPasskeyPromoViewDontRemindDate(date) {
    this._setStorageItem(STORAGE_CONSTANTS.VIEW_PASSKEY_PROMO, {
      date
    });
  }
  removePasskeyPromoViewDontRemindDate() {
    this._removeStorageItem(STORAGE_CONSTANTS.VIEW_PASSKEY_PROMO);
  }
  getPasskeyAutoEnrollAttempts() {
    const data = this._getStorageItem(STORAGE_CONSTANTS.PASSKEY_AUTO_ENROLL);
    return data?.attempts;
  }
  setPasskeyAutoEnrollAttempts(attempts) {
    const data = this._getStorageItem(STORAGE_CONSTANTS.PASSKEY_AUTO_ENROLL) ?? {};
    this._setStorageItem(STORAGE_CONSTANTS.PASSKEY_AUTO_ENROLL, {
      ...data,
      attempts
    });
  }
  getPasskeyAutoEnrollLastAttemptDate() {
    const data = this._getStorageItem(STORAGE_CONSTANTS.PASSKEY_AUTO_ENROLL);
    return data?.lastAttemptTimestamp;
  }
  setPasskeyAutoEnrollLastAttemptDate(timestamp) {
    const data = this._getStorageItem(STORAGE_CONSTANTS.PASSKEY_AUTO_ENROLL) ?? {};
    this._setStorageItem(STORAGE_CONSTANTS.PASSKEY_AUTO_ENROLL, {
      ...data,
      lastAttemptTimestamp: timestamp
    });
  }
  removePasskeyAutoEnroll() {
    this._removeStorageItem(STORAGE_CONSTANTS.PASSKEY_AUTO_ENROLL);
  }
  _hasSessionStorageItem(key) {
    try {
      return sessionStorage.getItem(this._getStorageKey(key)) !== null;
    } catch {
      return false;
    }
  }
  _getSessionStorageItem(key) {
    try {
      if (this._hasSessionStorageItem(key)) {
        return JSON.parse(sessionStorage.getItem(this._getStorageKey(key)));
      }
    } catch {
      return undefined;
    }
    return undefined;
  }
  _setSessionStorageItem(key, val) {
    try {
      sessionStorage.setItem(this._getStorageKey(key), JSON.stringify(val));
    } catch {
      // Storage may be disabled or quota exceeded
    }
  }
  _removeSessionStorageItem(key) {
    try {
      sessionStorage.removeItem(this._getStorageKey(key));
    } catch {
      // Storage may be disabled
    }
  }
  hasRiskMagicLinkBeenSent() {
    const data = this._getSessionStorageItem(STORAGE_CONSTANTS.RISK_MAGIC_LINK_SENT);
    if (!data || !data.timestamp) {
      return false;
    }
    const elapsed = Date.now() - data.timestamp;
    if (elapsed > StorageService.RISK_MAGIC_LINK_TTL_MS) {
      this.clearRiskMagicLinkSent();
      return false;
    }
    return true;
  }
  setRiskMagicLinkSent() {
    this._setSessionStorageItem(STORAGE_CONSTANTS.RISK_MAGIC_LINK_SENT, {
      sent: true,
      timestamp: Date.now()
    });
  }
  clearRiskMagicLinkSent() {
    this._removeSessionStorageItem(STORAGE_CONSTANTS.RISK_MAGIC_LINK_SENT);
  }
}
_defineProperty(StorageService, "RISK_MAGIC_LINK_TTL_MS", 5 * 60 * 1000);